import { html } from "../../base/_utils";
import staffModal from "./_staff-modal";

export default function staffCard(member, path, capColor) {
    const bioBtn = html`
        <div class="bio bg-primary d-flex justify-content-center align-items-center">
            <p class="h3 text-white text-uppercase">Read Bio</p>
        </div>
    `;

    const isThreeLineName = member.id === "karenWilliamsonConway";

    return html`
        <div class="card staff-card position-relative mb-5 ${!member.bio ? "no-bio" : ""}">
            <img class="wave-pattern img-fluid" src="${path}assets/media/global/elements/card-wave-bg-black.webp" alt="wave pattern" />
            <div class="card-body bg-secondary text-center position-relative z-1 eh">
                <${member.bio ? "button" : "div"} class="staff-img-wrapper bg-${capColor} border-0 mt-n6" ${member.bio ? `data-bs-target="#${member.id}-modal" data-bs-toggle="modal"` : ""}>
                    ${member.bio ? bioBtn : ""}
                    <img class="staff-image card-img-top position-relative z-1" src="${path}${member.image}" alt="${member.name} headshot" />
                </${member.bio ? "button" : "div"}>
                <h3 class="staff-name font-secondary text-uppercase text-primary mt-3">
                    ${
                        isThreeLineName
                            ? html`${member.name.split(" ")[0]}<br />${member.name.split(" ")[1]}<br />${member.name.split(" ")[2]}`
                            : html`${member.name.split(" ")[0]}<br />${member.name.split(" ")[1]}`
                    }
                </h3>
                <div class="title my-2 align-content-center ">
                    <p class="staff-title font-primary-bold mb-0">${member.title}</p>
                </div>
                <a class="staff-email small d-block w-fit-content mx-auto mb-2" href="mailto:${member.email}">${member.email}</a>
                <a class="staff-phone small d-block w-fit-content mx-auto" href="tel:+1${member.phone}">${member.phone}</a>
            </div>
        </div>
        ${staffModal(member, path)}
    `;
}
